module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    "use strict";
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n  var EncodingType = require(\'./NetSimConstants\').EncodingType;\n  var i18n = require(\'@cdo/netsim/locale\');\n\n  /**\n   * @param {EncodingType} encodingType\n   * @param {string} encodingLabel\n   */\n  function makeCheckbox(encodingType, encodingLabel) {\n    var divClasses = [\'encoding_checkboxes_\' + encodingType];\n    if (locals.level.showEncodingControls.indexOf(encodingType) === -1) {\n      divClasses.push(\'hidden-control\');\n    }\n    %>\n    <div class="<%= divClasses.join(\' \') %>">\n      <input type="checkbox"\n             name="encoding_checkboxes"\n             id="encoding_checkboxes_<%= encodingType %>"\n             value="<%= encodingType %>"\n          />\n      <label for="encoding_checkboxes_<%= encodingType %>"><%= encodingLabel %></label>\n    </div>\n    <%\n  }\n%>\n<div class="netsim-encoding-selector">\n  <h1><%= i18n.encoding() %></h1>\n  <% makeCheckbox(EncodingType.ASCII, i18n.ascii()); %>\n  <% makeCheckbox(EncodingType.DECIMAL, i18n.decimal()); %>\n  <% makeCheckbox(EncodingType.HEXADECIMAL, i18n.hexadecimal()); %>\n  <% makeCheckbox(EncodingType.BINARY, i18n.binary()); %>\n  <% makeCheckbox(EncodingType.A_AND_B, i18n.a_and_b()); %>\n</div>\n', __filename = "src/netsim/NetSimEncodingControl.html.ejs";
    try {
        var __output = "";
        function __append(s) {
            if (s !== undefined && s !== null) __output += s;
        }
        var EncodingType = require("./NetSimConstants").EncodingType;
        var i18n = require("@cdo/netsim/locale");
        function makeCheckbox(encodingType, encodingLabel) {
            var divClasses = [ "encoding_checkboxes_" + encodingType ];
            if (locals.level.showEncodingControls.indexOf(encodingType) === -1) {
                divClasses.push("hidden-control");
            }
            __line = 14;
            __append('\n    <div class="');
            __line = 15;
            __append(escapeFn(divClasses.join(" ")));
            __append('">\n      <input type="checkbox"\n             name="encoding_checkboxes"\n             id="encoding_checkboxes_');
            __line = 18;
            __append(escapeFn(encodingType));
            __append('"\n             value="');
            __line = 19;
            __append(escapeFn(encodingType));
            __append('"\n          />\n      <label for="encoding_checkboxes_');
            __line = 21;
            __append(escapeFn(encodingType));
            __append('">');
            __append(escapeFn(encodingLabel));
            __append("</label>\n    </div>\n    ");
            __line = 23;
        }
        __line = 25;
        __append('\n<div class="netsim-encoding-selector">\n  <h1>');
        __line = 27;
        __append(escapeFn(i18n.encoding()));
        __append("</h1>\n  ");
        __line = 28;
        makeCheckbox(EncodingType.ASCII, i18n.ascii());
        __append("\n  ");
        __line = 29;
        makeCheckbox(EncodingType.DECIMAL, i18n.decimal());
        __append("\n  ");
        __line = 30;
        makeCheckbox(EncodingType.HEXADECIMAL, i18n.hexadecimal());
        __append("\n  ");
        __line = 31;
        makeCheckbox(EncodingType.BINARY, i18n.binary());
        __append("\n  ");
        __line = 32;
        makeCheckbox(EncodingType.A_AND_B, i18n.a_and_b());
        __append("\n</div>\n");
        __line = 34;
        return __output;
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}